// extracted by mini-css-extract-plugin
export var alignBaseline = "_7-9";
export var alignCenter = "_7-5";
export var alignFlexEnd = "_7-7";
export var alignFlexStart = "_7-6";
export var alignSelfBaseline = "_7-e";
export var alignSelfCenter = "_7-a";
export var alignSelfFlexEnd = "_7-c";
export var alignSelfFlexStart = "_7-b";
export var alignSelfStretch = "_7-d";
export var alignStretch = "_7-8";
export var column = "_7-2";
export var columnReverse = "_7-4";
export var flex = "_7-0";
export var justifyCenter = "_7-f";
export var justifyFlexEnd = "_7-h";
export var justifyFlexStart = "_7-g";
export var justifySpaceAround = "_7-j";
export var justifySpaceBetween = "_7-i";
export var justifySpaceEvenly = "_7-k";
export var row = "_7-1";
export var rowReverse = "_7-3";
export var wrapNowrap = "_7-m";
export var wrapWrap = "_7-l";
export var wrapWrapReverse = "_7-n";